module.exports = __webpack_public_path__ + "dist/assets/60d79bea05def8040578a99668fb489d.svg";